export default "__VITE_ASSET__C_0ibJnY__"